export enum CivilStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
  REGISTERED_PARTNERSHIP = 'REGISTERED_PARTNERSHIP',
  DISSOLVED_PARTNERSHIP = 'DISSOLVED_PARTNERSHIP',
  SEPARATED = 'SEPARATED',
  UNKNOWN = 'UNKNOWN',
}

export const getCivilStatusLabel = (status: CivilStatus | string): string => {
  switch (status) {
    case CivilStatus.SINGLE:
      return $localize`Célibataire`;
    case CivilStatus.MARRIED:
      return $localize`Marié(e)`;
    case CivilStatus.DIVORCED:
      return $localize`Divorcé(e)`;
    case CivilStatus.WIDOWED:
      return $localize`Veuf(ve)`;
    case CivilStatus.REGISTERED_PARTNERSHIP:
      return $localize`Partenariat enregistré`;
    case CivilStatus.DISSOLVED_PARTNERSHIP:
      return $localize`Partenariat dissout`;
    case CivilStatus.SEPARATED:
      return $localize`Séparé(e)`;
    case CivilStatus.UNKNOWN:
      return $localize`Inconnu`;
    default:
      return status;
  }
};
